import * as React from "react";

import ReactModal from "./base/reactModal.js";
import styled, { createGlobalStyle } from "styled-components";
import { when } from "../styles/theme.js";
import Link from "./link.js";
import LangChange from "./langChange.js";
import { useState } from "react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { useLocalization } from "gatsby-theme-i18n";

const DisableBodyScroll = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;

const Modal = styled(ReactModal)`
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1100;
    overflow: hidden;
    display: flex;
    background: ${(props) => props.theme.colors.black};
    transition: transform 300ms ease-in-out;
    transform: translateX(100%);

    ${when("lg")} {
      display: none;
    }
  }
  .ReactModal__Overlay--after-open {
    transform: translateX(0);
  }
  .ReactModal__Overlay--before-close {
    transform: translateX(100%);
  }
  &__content {
    outline: none;
    overflow-y: auto;
    width: 100%;
    color: ${(props) => props.theme.colors.white};
    padding: 3rem;
  }
`;

const MainNav = styled.nav`
  display: flex;
  flex-direction: column;
  //align-items: flex-start;
  margin-top: 5rem;
`;

const MainNavLink = styled(Link)`
  padding: 2rem;
  display: block;
  font-size: 2rem;
  position: relative;

  &.active {
    color: ${(props) => props.theme.colors.gray};
  }
`;

const LangChangeContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  //padding-right: 3rem;
`;

const LangChangeButton = styled(LangChange)`
  width: 4.5rem;
  height: 4.5rem;
  // right: ${(props) => props.theme.pageContainerWidth.xs + 1.5}rem;
  //bottom: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  //position: absolute;
  border: 1px solid ${(props) => props.theme.colors.white};
  border-radius: 999px;
  font-size: 2rem;
  transform: translateY(-100%);

  ${when("sm")} {
    right: ${(props) => props.theme.pageContainerWidth.sm + 1.5}rem;
  }

  ${when("md")} {
    right: ${(props) => props.theme.pageContainerWidth.md + 1.5}rem;
  }
`;

const GlobalNav = styled.nav`
  display: flex;
  flex-direction: column;
  //align-items: flex-start;
`;

const GlobalNavTitle = styled.div`
  padding: 2rem;
  display: flex;
  font-size: 2rem;
  cursor: pointer;
  align-items: center;
`;

const GlobalNavLinks = styled.div`
  height: ${(props) => (props.isActive ? "auto" : "0")};
  overflow: hidden;
`;

const GlobalNavLink = styled.a`
  display: block;
  padding: 2rem;
  font-size: 2rem;
  margin-left: 2rem;
`;

const DownIcon = styled(BsChevronDown)`
  display: block;
  margin-left: 0.5rem;
`;

const UpIcon = styled(BsChevronUp)`
  display: block;
  margin-left: 0.5rem;
`;

const BrandNavLink = styled(Link)`
  display: block;
  padding: 0.5rem 1rem;
`;

const BrandNavLinkBold = styled(BrandNavLink)`
  font-weight: bold;
  margin-left: 2rem;
`;

const SubBrands = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: 4rem;
`;

const SubBrandLink = styled(Link)`
  padding: 1rem 2rem;
`;

const MobileMenu = ({
  isActive,
  setIsActive,
  mainNav,
  globalNav,
  originalPath,
  brands,
}) => {
  const [isGlobalActive, setIsGlobalActive] = useState(false);
  const { locale } = useLocalization();

  return (
    <Modal
      isOpen={isActive}
      onRequestClose={() => setIsActive(false)}
      closeTimeoutMS={300}
    >
      <DisableBodyScroll />
      <MainNav>
        {mainNav?.links.map((nav, index) => {
          if (nav.url.includes("business-overview")) {
            return (
              <div key={index}>
                <MainNavLink
                  href={nav.url}
                  activeClassName={"active"}
                  partiallyActive={nav.url !== "/"}
                  onClick={() => {
                    setIsActive(false);
                  }}
                >
                  {nav.title}
                </MainNavLink>
                <BrandNavLinkBold
                  href={
                    locale === "en"
                      ? "/en/business-overview#central-kitchen"
                      : "/business-overview#central-kitchen"
                  }
                >
                  {locale === "en" ? "Central Kitchen" : "中央廚房"}
                </BrandNavLinkBold>
                <BrandNavLinkBold
                  href={
                    locale === "en"
                      ? "/en/business-overview#packing-products"
                      : "/business-overview#packing-products"
                  }
                >
                  {locale === "en" ? "Packing Products" : "包裝產品"}
                </BrandNavLinkBold>
                <BrandNavLinkBold
                  href={
                    locale === "en"
                      ? "/en/business-overview#brands"
                      : "/business-overview#brands"
                  }
                >
                  {locale === "en" ? "Restaurants" : "旗下餐廳"}
                </BrandNavLinkBold>
                <SubBrands>
                  {brands.map((brand, index) => {
                    const link =
                      locale === "en"
                        ? `/en/restaurants/${brand.slug}`
                        : `/restaurants/${brand.slug}`;

                    return (
                      <SubBrandLink key={index} href={link}>
                        {brand.name}
                      </SubBrandLink>
                    );
                  })}
                </SubBrands>
              </div>
            );
          }
          return (
            <MainNavLink
              href={nav.url}
              key={index}
              activeClassName={"active"}
              partiallyActive={nav.url !== "/"}
              onClick={() => {
                setIsActive(false);
              }}
            >
              {nav.title}
            </MainNavLink>
          );
        })}
      </MainNav>
      <GlobalNav>
        <GlobalNavTitle
          onClick={() => {
            setIsGlobalActive(!isGlobalActive);
          }}
        >
          {globalNav?.title}
          {isGlobalActive ? <UpIcon /> : <DownIcon />}
        </GlobalNavTitle>
        <GlobalNavLinks isActive={isGlobalActive}>
          {globalNav?.links.map((nav, index) => {
            return (
              <GlobalNavLink href={nav.url} key={index} target={"_blank"}>
                {nav.title}
              </GlobalNavLink>
            );
          })}
        </GlobalNavLinks>
      </GlobalNav>
      <LangChangeContainer>
        <LangChangeButton originalPath={originalPath} />
      </LangChangeContainer>
    </Modal>
  );
};

export default MobileMenu;
